import { render, staticRenderFns } from "./EmployeeDetail.vue?vue&type=template&id=10057303&scoped=true"
import script from "./EmployeeDetail.vue?vue&type=script&lang=js"
export * from "./EmployeeDetail.vue?vue&type=script&lang=js"
import style0 from "./EmployeeDetail.vue?vue&type=style&index=0&id=10057303&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10057303",
  null
  
)

export default component.exports